import { Box } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IoShieldCheckmark } from 'react-icons/io5'

import { Tooltip } from '@/components/ui/tooltip'
import { isInsuranceCertificateValid } from '@/utils/insuranceCertificate'

type InsuranceCertificateBadgeProps = {
  insuranceCertificate?: {
    validatedAt?: string | null
    expiresAt?: string | null
  } | null
  size?: string | number
  user?: {
    firstname?: string | null
  } | null
  context?: 'user' | 'community'
}

export const InsuranceCertificateBadge: React.FC<
  InsuranceCertificateBadgeProps
> = ({ insuranceCertificate, size = '1.2em', user, context = 'community' }) => {
  const { t } = useTranslation()
  const isValid = isInsuranceCertificateValid(insuranceCertificate)

  if (!isValid) {
    return null
  }

  const tooltipText =
    context === 'user' && user?.firstname
      ? t('users.insuranceCertificate.validTooltip', {
          firstname: user.firstname,
        })
      : t('communities.insuranceCertificate.validTooltip')

  const icon = (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      color="blue.500"
      aria-label={tooltipText}
    >
      <IoShieldCheckmark size={size} />
    </Box>
  )

  return (
    <Tooltip content={tooltipText} showArrow>
      {icon}
    </Tooltip>
  )
}
